import { render, staticRenderFns } from "./drag-stus.vue?vue&type=template&id=e2eb0bfa&scoped=true&"
import script from "./drag-stus.vue?vue&type=script&lang=js&"
export * from "./drag-stus.vue?vue&type=script&lang=js&"
import style0 from "./drag-stus.vue?vue&type=style&index=0&id=e2eb0bfa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eb0bfa",
  null
  
)

export default component.exports